import { render } from "./TextFileIcon.vue?vue&type=template&id=366643da&bindings={}"
import script from "./TextFileIcon.vue?vue&type=script&lang=js"
export * from "./TextFileIcon.vue?vue&type=script&lang=js"
script.render = render

export default script